export default __webpack_public_path__ + "images/6d695974e39c8dc0b2ca22ee7796dda9.png";